import React from 'react'

const TimelineEntry = ({ week, direction }) => {
    return (
        <div className={`mb-8 flex justify-between items-center w-full ${direction == "left" ? "flex-row-reverse left-timeline" : "right-timeline"}`}>
            <div className="order-1 w-5/12"></div>
            <div className="z-20 flex items-center order-1 bg-gray-800 w-8 h-8 rounded-full">
                <h1 className="mx-auto font-semibold text-lg text-white font-title">{week.weekNumber}</h1>
            </div>
            <div className={`order-1 ${direction == "left" ? "bg-secondary" : "bg-gray-300"} rounded-lg w-5/12 px-6 py-4`}>
                <h3 className={`mb-3 font-bold ${direction == "left" ? "text-gray-100" : "text-gray-900"} text-xl font-title`}>Week {week.weekNumber}</h3>
                <div className={`text-sm leading-snug ${direction == "left" ? "text-gray-100" : "text-gray-900"} tracking-wide text-opacity-100`}>
                    {week.entries.map((entry, index) => {
                        return (
                            <ul key={index} className="text-left py-2 text-lg">
                              <li>
                                 <span className="font-bold">{entry.date}</span> {entry.topic}
                               <ul className="list-disc list-inside ml-4">
                                  {entry.items.map((item, index) => (
                             <li key={index}>{item}</li>
            ))}
        </ul>
    </li>
</ul>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}

export default TimelineEntry;


// WEBPACK FOOTER //
// ./src/components/TimelineEntry.jsx